import { AppError } from './app-error';

export class ConflictError extends AppError {}
